import React, { FC, useEffect } from 'react'
import { LoginCallback, useOktaAuth } from '@okta/okta-react'

import { isFirstLoginVar } from 'modulesCommon/store'
import { ErrorPageContent } from 'components'
import { ClientError } from 'modules/Errors/components'
import { useNavigate } from 'react-router-dom'

const LoginCallbackContainer: FC = () => {
  const navigate = useNavigate()
  const { oktaAuth } = useOktaAuth()
  useEffect(() => {
    isFirstLoginVar(true)
    if (!oktaAuth.isLoginRedirect()) {
      navigate('/')
    }
  }, [oktaAuth, navigate])

  return <LoginCallback
    errorComponent={({ error }) => (
      <ErrorPageContent
        title={error.name}
        description={error.message}
        children={<ClientError />}
      />
    )}
  />
}

export default LoginCallbackContainer
